/* global __DEV__ */
/* eslint-disable global-require */
import '@binance/performance';
import React from 'react';
import App, { Container } from 'next/app';
import { createStore, applyMiddleware } from 'redux';
// eslint-disable-next-line import/no-unresolved
import { GlobalStyle, ThemeProvider, darkTheme } from '@binance/uikit';
import { Provider } from 'react-redux';
import withReduxApp from 'next-redux-wrapper';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunkMiddleware from 'redux-thunk';
import Head from 'next/head';
import { reducer, initialState } from '../store/reducer';
import { getLocales, getHtmlLang } from '../utils/locales';
import { removeQueryStr } from '../utils/canonical';
import popstateListener from '../config/router/popstate';

const middleware = __DEV__
  ? [require('redux-freeze'), thunkMiddleware]
  : [thunkMiddleware];

export const initStore = (state = initialState) => createStore(
  reducer,
  state,
  composeWithDevTools(applyMiddleware(...middleware))
);

const LOCALES = getLocales();
const LOCALES_KEYS = Object.keys(LOCALES);

/* eslint-disable react/prop-types */
export default
@withReduxApp(initStore)
class MainApp extends App {
  constructor(...args) {
    super(...args);
    popstateListener();
  }

  static async getInitialProps({ Component, ctx }) {
    const pageProps = Component.getInitialProps
      ? await Component.getInitialProps(ctx)
      : {};

    const { locale } = ctx.query;
    let canonical = ctx.req ? `https://${ctx.req.get('host')}${ctx.req.url}` : `${window.location.origin}${window.location.pathname}`;

    canonical = removeQueryStr(canonical);
    return { pageProps, canonical, lang: locale };
  }

  _replaceLocale = (url, locale) => {
    const { lang } = this.props;
    const _urls = url.split('/');

    if (_urls.length > 4) {
      return url.replace(`/${lang}/`, `/${locale}/`);
    }
    return url.replace(`/${lang}`, `/${locale}`);
  }

  renderCanonicals = () => {
    const { pageProps, canonical } = this.props;

    if (pageProps.canonicals) {
      return pageProps.canonicals.map(item => <link
        key={item.lang}
        rel="alternate"
        hrefLang={item.lang}
        href={item.href}
      />
      );
    }

    return LOCALES_KEYS.map(locale => (
      <link
        key={locale}
        rel="alternate"
        hrefLang={getHtmlLang(locale)}
        href={this._replaceLocale(canonical, locale)}
      />
    ));
  }

  render() {
    const {
      Component, pageProps, store,
    } = this.props;
    return (
      <Container>
        <ThemeProvider theme={darkTheme}>
          <GlobalStyle />
        </ThemeProvider>
        <Head>
          {this.renderCanonicals()}
        </Head>

        <Provider store={store}>
          <Component {...pageProps} />
        </Provider>
      </Container>
    );
  }
}
